/**
 * The JavaScript code you place here will be processed by esbuild, and the
 * output file will be created at `../build/js/script.min.js` and enqueued in
 * `../theme/functions.php`.
 *
 * For esbuild documentation, please see:
 * https://esbuild.github.io/
 */

function dropdownHandler(element) {
  let single = jQuery(element).find("ul").first();
  single.toggleClass("hidden");
}

function MenuHandler(el, val) {
  let MainList = jQuery(el).parent().find("ul").first();
  let closeIcon = jQuery(el).parent().find(".close-m-menu").first();
  let showIcon = jQuery(el).parent().find(".show-m-menu").first();

  if (val) {
    MainList.removeClass("hidden");
    jQuery(el).addClass("hidden");
    closeIcon.removeClass("hidden");
  } else {
    showIcon.removeClass("hidden");
    MainList.addClass("hidden");
    jQuery(el).addClass("hidden");
  }
}

let sideBar = jQuery("#mobile-nav");
let menu = jQuery("#menu");
let dropdown = jQuery(".dropdown");
let mobDropdown = jQuery(".mobDropDown");
let cross = jQuery("#cross");
sideBar.css("transform", "translateX(-100%)");

dropdown.hover(function(e) {
  dropdownHandler(e.currentTarget);
});
mobDropdown.on('click',function(e) {
  // if(e.currentTarget.hasClass('no-click')){
  //   e.preventDefault();
  // }
  listHandler(e.currentTarget);
});

AOS.init();

menu.on('click', function(event) {
  sidebarHandler(!menu.hasClass('hidden'));
});

cross.on('click', function(event) {
  sidebarHandler(!menu.hasClass('hidden'));
});

const sidebarHandler = (check) => {
  if (check) {
    sideBar.css("transform", "translateX(0px)");
    menu.addClass("hidden");
    cross.removeClass("hidden");
  } else {
    sideBar.css("transform", "translateX(-100%)");
    menu.removeClass("hidden");
    cross.addClass("hidden");
  }
};

const listHandler = (ele) => {
  jQuery('.list').addClass("hidden");;
  jQuery('.chevrondown').addClass("hidden");;
  jQuery('.chevronup').removeClass("hidden");;
  jQuery(ele).find('.list').toggleClass("hidden");
  jQuery(ele).find('.chevrondown').toggleClass("hidden");
  jQuery(ele).find('.chevronup').toggleClass("hidden");
};

let modal = jQuery("#modal");
jQuery('._modal,a[href=#quote]').on('click',function (e){
  e.preventDefault();
  fadeIn(modal)
});
jQuery('.close_modal').on('click',function (e){
  e.preventDefault();
  fadeOut(modal)
});
function fadeOut(el) {
  jQuery(el).css('opacity', 1);
  jQuery(el).animate({ opacity: 0 }, {
    duration: 500,
    complete: function() {
      jQuery(el).hide();
    }
  });
  jQuery("body").css("overflow", "visible");
}

function fadeIn(el) {
  jQuery(el).css('opacity', 0);
  jQuery(el).show().animate({ opacity: 1 }, {
    duration: 500
  });
  jQuery("body").css("overflow", "hidden");
}

(function ($) {
  $(document).ready(function () {
    var currentPage = 1;
    $('#category_dropdown').click(function (e) {
      e.stopPropagation();
      showDropDownMenu(this);
    });

    $('.category-option.static').click(function (event) {
      event.preventDefault();
      let targetText = $(this).find('a').text();
      if(targetText == 'All'){
        targetText = 'Select Category';
      }
      $('#drop-down-content-setter_dropdown_3').html(targetText);
      $('#drop-down-div_dropdown_3').addClass('hidden');
      var category = $(this).find('a').attr('data-term_id');
      $('.category-link').removeClass('active')
      $(this).addClass('active')

      if (history.pushState) {
        var newUrl = $(this).find('a').attr('href');
        window.history.pushState({path: newUrl}, '', newUrl);
      }
      if($(this).not().attr('id') == 'all_option') {
        $('#all_option').removeClass('hidden')
      }else{
        $('#all_option').addClass('hidden')
      }
      window.location.href = newUrl;
    });
  });

  function showDropDownMenu(el) {
    $(el).parent().children(':nth-child(2)').addClass('active').toggleClass('hidden');
  }

})(jQuery);

